import tw, { styled } from "twin.macro"

export const Footer = tw.footer`relative`
export const SocialMedia = styled.div`
  ${tw`absolute left-1/2 flex items-center justify-center gap-2 text-2xl px-10 py-2 bg-white rounded-full text-primary shadow-lg border`}
  transform: translateX(-50%) translateY(-6vh)
`
export const FooterWrap = tw.div`text-gray-600 bg-gray-300 pt-10 pb-8 text-center`
export const Copyright = tw.div`text-sm font-semibold py-1`
